import { render } from "./UnderReview.vue?vue&type=template&id=524e6d43"
import script from "./UnderReview.vue?vue&type=script&lang=js"
export * from "./UnderReview.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__